import { useModal } from "@ebay/nice-modal-react";
import { t } from "@/i18n-js/instance";
import { Modal } from "@circle-react-uikit/ModalV2";
import { useAddContentModal } from "../AddContentModal";
import { Content } from "../SnippetForm/Content";
import { Header } from "../SnippetForm/Header";
import { useCreateSnippet } from "../snippetsQueries";

export interface Snippet {
  body: string;
  title: string;
}

export const AddSnippetModalComponent = () => {
  const modal = useModal();
  const createSnippetMutation = useCreateSnippet({ onSuccess: modal.remove });
  const addContentModal = useAddContentModal();
  return (
    <Modal isOpen={modal.visible} onClose={modal.hide}>
      <Modal.Overlay />
      <Modal.Content
        size="auto"
        className="h-full max-h-full max-w-[720px] overflow-visible !rounded-t-none sm:h-full sm:!rounded-t-lg md:max-h-[80vh] lg:max-h-[550px]"
      >
        <Header
          title={t(
            "settings.community_bot.knowledge.custom.create_modal.title",
          )}
        />
        <Content
          defaultValues={{}}
          onSubmit={(data: Snippet) => createSnippetMutation.mutate(data)}
          actionLabel={t("settings.community_bot.knowledge.custom.add")}
          onBack={() => {
            void modal.hide();
            void addContentModal.show();
          }}
        />
      </Modal.Content>
    </Modal>
  );
};
